/**
 * Vue Router
 *
 * @requires vue
 * @requires vue-router
 */

import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '@/lib/store'

Vue.use(VueRouter)

const router = new VueRouter({
	mode: 'history',
	routes,
})

router.beforeEach((to, from, next) => {
	let requiresAuth = null

	for (const match of to.matched) {
		if (match.meta.requiresAuth) {
			requiresAuth = true
		}
	}

	if (requiresAuth) {
		store.dispatch('initUser')
			.then(res => {
				next()
			}).catch(err => {
				next({ name: 'login' })
				console.warn(`Login required.`, err)
			})
	} else {
		next()
	}
})

export default router



// WEBPACK FOOTER //
// ./src/lib/router/index.js